import { useState, useCallback } from 'react';
import { transformOneApiResponse, transformCmaApiResponse, transformNewMscApiResponse } from '../transforms/schesdulesTasnforms';

// Hook personalizado para gerenciar o estado do modal e busca de dados
const useScheduleModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dataModal, setDataModal] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);
  const [error, setError] = useState(null);
  const [params, setParams] = useState(null);

  const openModal = useCallback(
    async ({ originCode, destinationCode, startDate, endDate, company }) => {
      setIsOpen(true);
      setError(null);
      setDataModal([]);
      setParams({ originCode, destinationCode, startDate, endDate, company });

      if (company === "one") {
        setLoadingModal(true);
        try {
          const url = new URL(
            "https://ecomm.one-line.com/api/v1/schedule/point-to-point"
          );
          url.searchParams.append("porCode", originCode);
          url.searchParams.append("delCode", destinationCode);
          url.searchParams.append("rcvTermCode", "Y");
          url.searchParams.append("deTermCode", "Y");
          url.searchParams.append("tsFlag", "");
          url.searchParams.append("fromDate", startDate);
          url.searchParams.append("toDate", endDate);
          url.searchParams.append("polCode", "");
          url.searchParams.append("podCode", "");
          url.searchParams.append("polYardCode", "");
          url.searchParams.append("podYardCode", "");
          url.searchParams.append("standardizationEtaEtb", "true");
          url.searchParams.append("cargoNature", "GP");
          url.searchParams.append("searchType", "Calendar");

          const response = await fetch(url.toString());
          if (!response.ok) {
            throw new Error("Erro ao buscar dados da API ONE");
          }
          const json = await response.json();
          const transformed = transformOneApiResponse(json);
          setDataModal(transformed);
        } catch (err) {
          setError(err.message || "Erro desconhecido");
        } finally {
          setLoadingModal(false);
        }
      } else if (company === "msc") {
        setLoadingModal(true);
        try {
          const url = "https://msc.zarpar-beta.net/search";
          const body = {
            originCode,
            destinationCode,
            fromDate: startDate,
          };

          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error("Erro ao buscar dados da API MSC");
          }
          const json = await response.json();
          const transformed = transformNewMscApiResponse(json);
          setDataModal(transformed);
        } catch (err) {
          setError(err.message || "Erro desconhecido");
        } finally {
          setLoadingModal(false);
        }
      } else if (company === "cmacgm") {
        setLoadingModal(true);
        try {
          const url = "https://cma.zarpar-beta.net/search";
          const body = {
            originCode,
            destinationCode,
            fromDate: startDate,
          };

          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });

          if (!response.ok) {
            throw new Error("Erro ao buscar dados da API CMA CGM");
          }
          const json = await response.json();
          const transformed = transformCmaApiResponse(json);
          setDataModal(transformed);
        } catch (err) {
          setError(err.message || "Erro desconhecido");
        } finally {
          setLoadingModal(false);
        }
      } else {
        setDataModal([]);
      }
    },
    []
  );

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setDataModal([]);
    setError(null);
    setParams(null);
  }, []);

  return { isOpen, dataModal, loadingModal, error, params, openModal, closeModal };
};

export default useScheduleModal;
